document.addEventListener("DOMContentLoaded", function () {
  window._paq = window._paq || [];
  window._paq.push([
    "setEcommerceView",
    String(productData.id), // 产品ID
    productData.title, // 产品标题
    productData.type, // 产品分类
    productData.price_min, // 产品价格
  ]);

  window._paq.push(["trackPageView"]);
  const tipsElements = document.querySelectorAll(".product-tips");
  const tipsContentElements = document.querySelectorAll(
    ".product-tips .product-tips-content"
  );
  tipsElements.forEach((item) => {
    item.addEventListener("click", () => {
      tipsContentElements.forEach((content) => {
        content?.classList.remove("visible");
      });
      item.querySelector(".product-tips-content")?.classList.add("visible");
    });
  });

  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const trident = ua.indexOf("Trident/");

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const hiddenInput = document.querySelector(
    '#{{ product_form_id }} input[name="id"]'
  );
  const noScriptInputWrapper = document.createElement("div");
  const variantSwitcher =
    document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
    document.querySelector('variant-selects[data-section="{{ section.id }}"]');
  noScriptInputWrapper.innerHTML = document.querySelector(
    ".product-form__noscript-wrapper-{{ section.id }}"
  ).textContent;
  variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

  document
    .querySelector("#Variants-{{ section.id }}")
    ?.addEventListener("change", function (event) {
      hiddenInput.value = event.currentTarget.value;
    });
});

document.addEventListener("click", (event) => {
  if (
    event.target?.classList.contains("product-tips") ||
    event.target?.parentNode?.classList.contains("product-tips") ||
    event.target?.parentNode?.parentNode?.classList.contains("product-tips")
  ) {
    return;
  }
  const tipsElements = document.querySelectorAll(".product-tips");
  tipsElements.forEach((item) => {
    item.querySelector(".product-tips-content")?.classList.remove("visible");
  });
});
// let inputEle = ;
document
  .getElementById("showAllImages")
  ?.addEventListener("click", function () {
    document.getElementById("hiddenImages").style.display = "block";
    this.style.display = "none"; // 隐藏按钮
  });

document
  .getElementById("showDetailImages")
  ?.addEventListener("click", function () {
    const element = document.getElementById("detailImages");
    const icon = document.querySelector("#showDetailImages .mmopnericon");
    if (element.style.display === "none") {
      element.style.display = "block";
      icon.classList.add("mmopnericontop");
    } else {
      element.style.display = "none";
      icon.classList.remove("mmopnericontop");
    }
  });

// var mySwiper = new Swiper(".swiper-container-delivery", {
//   slidesPerView: "auto",
//   pagination: {
//     el: ".swiper-pagination",
//     type: "fraction",
//   },
//   uniqueNavElements: true,
//   spaceBetween: 10,
//   observer: true,
//   observeParents: true,
//   observeSlideChildren: true,
//   // rtl: true, // 设置为从右到左轮播
// });

var verticalSwiper = new Swiper(".vertical-swiper", {
  direction: "vertical",
  loop: true,
  autoplay: true,
});

// var email = document.querySelector(".hmuser").dataset.email;
if (theme.isLogin()) {
  reportVisit();
  document.querySelector("#login-prompt")?.classList?.add("hidden");
  document.querySelector("#sold-recently")?.classList?.remove("hidden");
}
function reportVisit() {
  const href = window.location.href;
  const productAdapter = new ProductApi();
  productAdapter.addHistory(href);
}

function getIsFreeShipping() {
  const params = {
    id: [String(productData.id)],
  };
  fetchConnect(
    "web.ProductService/QueryProductFreeShipping",
    "POST",
    params
  ).then((response) => {
    if (!response.error) {
      const data = response?.data?.items;
      if (data[productData.id]) {
        document.querySelector(".free-ship")?.classList?.remove("hidden");
      }
    }
  });
}

// 判断变体是否免邮
// function getVarIsFreeShipping() {
//   if (!productData.variants) {
//     return;
//   }
//   const variantId = [];
//   productData.variants.forEach((variant) => {
//     variantId.push(String(variant.id));
//   });
//   const params = { id: variantId };
//   fetchRequest("api/v1/product/free-v", "POST", params).then((response) => {
//     if (!response.error) {
//       const data = response.data;
//       for (let i in data) {
//         if (data[i]) {
//           const freeShipEle = document.querySelector(
//             `.free-shipping-btn[data-varid="${i}"]`
//           );
//           freeShipEle?.classList.remove("hidden");
//         }
//       }
//     }
//   });
// }

function getSimilarProduct() {
  const params = {
    id: String(productData.id),
    title: productData.title,
    size: 5,
  };
  fetchRequest("api/v1/product/similar", "POST", params).then((response) => {
    if (!response.error) {
      const data = response.data;
      renderSimilarProduct(data);
      theme.getIsFreeShipping();
    }
  });
}

function formatPrice(item) {
  const jsonString = theme.getCookies("userSelected");
  const userSelected = theme.inspectJson(jsonString);
  const currencyCode = userSelected?.currency_code ?? "USD";
  const currencySymbol = decodeURIComponent(
    userSelected?.currency_symbol ?? "US$"
  );
  const newMaxPrice = theme.convertCurrency(item.max_price, "usdToSet");
  const newMinPrice = theme.convertCurrency(item.min_price, "usdToSet");
  if (item.max_price == item.min_price) {
    return `${currencySymbol}${newMaxPrice}`;
  } else {
    return `${currencySymbol}${newMinPrice} - ${newMaxPrice}`;
  }
}

function renderSimilarProduct(data) {
  let str = "";
  const similarEle = document.querySelector(".similar-product");
  const listEle = similarEle?.querySelector(".similar-product .list");
  const sectionId = similarEle?.dataset?.sectionId;
  data.forEach((item) => {
    const productUrl = `/products/${item.handle}`;
    const img = item.featured_image;
    const price = formatPrice(item);
    const ele = `<div class="grid__item bg-white">
      <div class="card-wrapper wbproduct-container product-card-wrapper center">
        <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
          <div class="card__inner  color-scheme-abe3bc68-5409-41dd-abcf-8f9ac474947a gradient wbimgblock  ratio" style="--ratio-percent: 100.0%;">
            <div id="webipro-${sectionId}-${item.id}" class="card__media ">
              <div class="product__media-item" data-media-id="${sectionId}-${item.id}">
                <a href="${productUrl}" target="_blank" title="${item.title}" class="media media--transparent media-- media--hover-effect">
                  <img srcset="${img}?width=165 165w,${img}?width=360 360w,${img}?width=533 533w,${img}?width=720 720w,${img}" 
                    src="${img}?width=360" sizes="(min-width: 1600px) 367px, (min-width: 992px) calc((100vw - 130px) / 4), (min-width: 768px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="" class="motion-reduce" loading="lazy" width="800" height="800">
                </a>
              </div>
            </div>
          </div>
          <div class="relative ">
            <wb-card-variant>
              <div class="swiper-tag">
                <div class="swiper-wrapper">
                  <div class="flex swiper-slide">
                    <span class="million-tag">Sign up for $1M Subsidy</span>
                  </div>

                  <div
                    class="flex swiper-slide free-shipping hidden"
                    data-id="${item.id}"
                  >
                    <span
                      class="free-shipping-tag"
                      >free shipping</span
                    >
                  </div>
                </div>
              </div>
              <div class="flex justify-space-between align-items-baseline">
                <div class="card_sale_price price">
                  <span
                    class="price-item price-item--regular notranslate"
                  >
                    ${price}
                  </span>
                </div>
                <div class="wb_select_btnaa1">
                  <modal-opener data-modal="#QuickAdd">
                  <button id="quick-add-${sectionId}${item.id}-submit" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog" aria-labelledby="quick-add-${sectionId}${item.id}-submit title-${sectionId}-${item.id}" data-product-url="${productUrl}" data-gpo-collection-item-handle="${item.handle}" data-product-id="${item.id}">
                      <span class="hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                        </svg>
                        Select options
                      </span>
                      <div>
                        <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                      </div>
                      <div class="loading-overlay__spinner hidden">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </modal-opener>
                </div>
              </div>
            </wb-card-variant>
          </div>
        </div>
      </div>
    </div>`;
    str += ele;
  });
  listEle ? (listEle.innerHTML = str) : "";
}

async function getEndTime() {
  const params = {
    group: "flash",
    marketing: "web",
  };
  const response = await fetchConnect(
    `web.MetaWebService/SearchMetaWeb`,
    "POST",
    params
  );

  if (!response.error) {
    const responseData = response.data;
    const flashData = responseData?.items.find(
      (item) => item.field === "flash"
    );
    return flashData;
  }
  return null;
}

async function startCountdown() {
  const countdownSection = document.querySelector(".product_timer");
  let flashData = await getEndTime();
  if (!countdownSection || !flashData) return;

  let count = 0;
  const time = theme.formatDateTime(flashData.flashEndTime);
  let countdownData = theme.countdown(time, false);
  const updateTimer = async () => {
    if (
      countdownData.hours == 0 &&
      countdownData.seconds == 0 &&
      countdownData.minutes == 0 &&
      count < 1
    ) {
      count++;
      flashData = await getEndTime();
    }
    const newTime = theme.formatDateTime(flashData.flashEndTime);
    countdownData = theme.countdown(newTime, false);
    // 更新显示
    countdownSection.querySelector(".wb_chours").textContent =
      countdownData.hours;
    countdownSection.querySelector(".wb_cminutes").textContent =
      countdownData.minutes;
    countdownSection.querySelector(".wb_cseconds").textContent =
      countdownData.seconds;
  };

  // 启动定时器
  const interval = setInterval(updateTimer, 1000);
  updateTimer(); // 立即执行一次
  // 返回清理函数
  return () => clearInterval(interval);
}

(function () {
  startCountdown();
  const urlParams = new URLSearchParams(window.location.search);
  const isFlash = decodeURIComponent(urlParams.get("flash"));
  if (isFlash === "true") {
    const countdownEle = document.querySelector(".countdown_timer");
    countdownEle?.classList.remove("hidden");
  }

  getIsFreeShipping();
  // getVarIsFreeShipping();
  getSimilarProduct();
  // getReviewCount();
  // getReviewList();
})();

document
  .querySelector(".product-right .copy-code-btn")
  ?.addEventListener("click", () => {
    const code = document.querySelector(".product-right .copy-code").dataset
      .countCode;
    navigator.clipboard.writeText(code.trim());
    showSuccess();
  });

document.querySelector(".share-btn.facebook")?.addEventListener("click", () => {
  const url = window.location.href;
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    "_blank"
  );
});

document.querySelector(".share-btn.tweet")?.addEventListener("click", () => {
  const url = window.location.href;
  window.open(
    `https://x.com/intent/post?text=${encodeURIComponent(url)}`,
    "_blank"
  );
});

document.querySelector(".share-btn.email")?.addEventListener("click", () => {
  const url = window.location.href;
  window.open(`mailto://help@gooddiy.com`, "_blank");
});

function formatDate(date) {
  const newDate = new Date(date);
  const formatter = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return formatter.format(newDate);
}

function renderRandomRate(dom) {
  const randomNumber = Math.random() * (5 - 4.7) + 4.7;
  const percent = (randomNumber / 5) * 100;
  const element = document.querySelector(`${dom}`);
  element.querySelector(".determinate").style.width = `${percent}%`;
  element.querySelector(".random-rate").innerHTML = randomNumber.toFixed(1);
}

function maskMiddleOfEnglishName(name) {
  if (name.length <= 6) {
    return name;
  }
  const firstThree = name.slice(0, 3);
  const lastThree = name.slice(-3);
  const middle = name.length > 6 ? "***" : "";
  return `${firstThree}${middle}${lastThree}`;
}

function renderRate(rate) {
  let str = "";
  for (let i = 0; i < 5; i++) {
    if (i < Math.round(rate)) {
      str += `<div class="rate-item rate-item-active">
                    <i class="base-icon">
                      <svg viewBox="0 0 512 512">
                        <path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"></path>
                      </svg>
                    </i>
                  </div>`;
    } else {
      str += `<div class="rate-item">
                    <i class="base-icon">
                      <svg viewBox="0 0 512 512">
                        <path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"></path>
                      </svg>
                    </i>
                  </div>`;
    }
  }
  return str;
}

function renderReview(dataList, total) {
  let str = ``;
  const listEle = document.querySelector(".review-list");
  listEle.innerHTML = str;
  if (total > 0) {
    dataList.forEach((item) => {
      const firstName = item.nickname.substring(0, 1);
      const date = formatDate(item.created_time.split(" ")[0]);
      const name = maskMiddleOfEnglishName(item.nickname);
      const rateStr = renderRate(item.score);
      str += `<div class="review-item">
              <div class="flex align-items-center">
                <div class="first-name">${firstName}</div>
                <div class="nickname">${name}</div>
                <div class="color-gray font-size-13" style="margin: 0 6px;">in <img style="width: 20px;margin-left: 4px;" alt="${
                  item.country
                }" src="https://assets.gooddiy.com/area/${item.country.toLowerCase()}.png"></div>
                <div class="color-gray font-size-13">on ${date}</div>
              </div>
              <div class="border-left">
                <div class="flex" style="gap: 6px">
                  ${rateStr}
                </div>
                <div class="review-content">${item.content}</div>
              </div>
              <div property="review" typeof="Review" class="hidden">
                Reviews:
                <span property="reviewRating" typeof="Rating"> <span property="ratingValue">${
                  item.score
                }</span> - </span>
                <b>"A masterpiece of literature" </b> by
                
                <span property="author" typeof="Person">
                  <span property="name">${item.nickname}</span>
                </span>, written on <meta property="datePublished" content="${
                  item.created_time
                }">${date}
                <div>
                  ${item.content}
                </div>
              </div>
            </div>`;
    });
    listEle.innerHTML = str;
  }
}

var size = 5;
var page = 1;
var totalPage = 0;
var filter = null;
function getReviewList() {
  const params = {
    product_id: String(productData.id),
    page: page,
    size: size,
    sort: 3,
    filter: filter,
  };
  fetchRequest("api/v1/product/comments", "POST", params)
    .then((response) => {
      if (!response.error) {
        // const reviewEle = document.querySelector(".review");
        // if (parsedState?.data?.total == 0 && page == 1) {
        //   reviewEle.classList.add("hidden");
        // } else {
        //   reviewEle.classList.remove("hidden");
        renderReview(response?.data?.list, response?.data?.total);
        const totalPageEle = document.querySelector(".pagenation .total-pages");
        const currentPageEle = document.querySelector(
          ".pagenation .current-page"
        );
        totalPage = Math.ceil(response?.data?.total / size);
        totalPageEle.textContent = totalPage;
        currentPageEle.innerHTML = page;
        inputEle.value = page;
        // renderRandomRate(".random-rate-1");
        // renderRandomRate(".random-rate-2");
        // renderRandomRate(".random-rate-3");
        // }
      }
    })
    .catch(() => {
      // this.setErrorMessage(window.cartStrings.error);
    });
}

function renderReviewCount(data) {
  const averageEle = document.querySelectorAll(".average-rate");
  const averageCountEle = document.querySelectorAll(".average-count");
  const averageRateEle = document.querySelector(".review-rate");
  averageEle?.forEach((average) => {
    average.textContent = data?.average?.toFixed(1);
    average.setAttribute("content", data?.average?.toFixed(1));
  });
  averageCountEle?.forEach((average) => {
    average.textContent = data?.count;
    average.setAttribute("content", data?.count);
  });
  const rate = Math.ceil(data?.average);
  const rateStr = renderRate(rate);
  averageRateEle.innerHTML = rateStr;
  // average
  // count
}
// function getReviewCount() {
//   fetch(`${url}/product/comment-stat?id=${String(productData.id)}`)
//     .then((response) => {
//       return response.text();
//     })
//     .then((state) => {
//       const parsedState = JSON.parse(state);
//       if (parsedState.code == 200) {
//         const reviewEle = document.querySelector(".review");
//         if (parsedState.data?.average == 0) {
//           const reviewSlideEle = document.querySelector(".review-slide");
//           reviewSlideEle.classList.add("hidden");
//           reviewSlideEle.remove();
//           verticalSwiper.update();
//         } else {
//           reviewEle.classList.remove("hidden");
//           renderReviewCount(parsedState.data);
//         }
//       }
//     })
//     .catch(() => {
//       // this.setErrorMessage(window.cartStrings.error);
//     });
// }

document.querySelector("#downBtn")?.addEventListener("click", () => {
  const imageUrls = [];
  productData.media.forEach((media) => {
    const src = `https:${media?.src?.split("?")[0]}`;
    imageUrls.push(src);
  });
  const zip = new JSZip();
  const promises = imageUrls.map((url) =>
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const filename = url.split("/").pop();
        zip.file(filename, blob);
      })
  );

  Promise.all(promises).then(() => {
    zip.generateAsync({ type: "blob" }).then((content) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(content);
      link.download = `GOODIYJEWELRY-${productData.id}.zip`;
      link.click();
    });
  });
});

// document
//   .querySelector(".pagenation .pagenation-btn-pre")
//   ?.addEventListener("click", () => {
//     if (page > 1) {
//       page--;
//       getReviewList();
//     }
//   });
// document
//   .querySelector(".pagenation .pagenation-btn-next")
//   ?.addEventListener("click", () => {
//     if (page < totalPage) {
//       page++;
//       getReviewList();
//     }
//   });
// document
//   .querySelector(".pagenation .enter-page")
//   ?.addEventListener("keydown", function (event) {
//     if (event.key === "Enter") {
//       page = parseInt(inputEle.value);
//       if (page > totalPage || page < 1) {
//         page = 1;
//       }
//       getReviewList();
//     }
//   });

function removeActive() {
  const itemListEle = document.querySelectorAll(".review .review-sort-item");
  itemListEle.forEach((item) => {
    item.classList?.remove("active");
  });
}

// document
//   .querySelector(".review .review-sort-all")
//   ?.addEventListener("click", (event) => {
//     page = 1;
//     filter = null;
//     removeActive();
//     getReviewList();
//     event.target?.classList?.add("active");
//   });
// document
//   .querySelector(".review .review-sort-four")
//   ?.addEventListener("click", (event) => {
//     page = 1;
//     filter = 4;
//     removeActive();
//     event.target?.classList?.add("active");
//     getReviewList();
//   });
// document
//   .querySelector(".review .review-sort-five")
//   ?.addEventListener("click", (event) => {
//     page = 1;
//     filter = 5;
//     removeActive();
//     event.target?.classList?.add("active");
//     getReviewList();
//   });
// 图搜

document.querySelector("#picture-search")?.addEventListener("click", () => {
  const imgUrl = document
    .querySelector(".product-gallery-main .swiper-slide-active")
    ?.querySelector("img")?.src;
  getSearchRemoteResult(imgUrl);
});

// 获取远程图搜结果
function getSearchRemoteResult(imgUrl) {
  this.isLoading = true;
  fetchRequest("api/v1/product/image/remote", "POST", { id: imgUrl }).then(
    (responseData) => {
      if (!responseData.error) {
        const image = responseData.data;
        window.open(`/pages/picture-search?imageUrl=${image}`, "_blank");
      }
    }
  );
}

// 显示成功提示
function showSuccess() {
  const message = document.getElementById("promptMessage");
  message?.classList.remove("hidden");
  message?.classList.add("show");
  var timer = setTimeout(() => {
    clearTimeout(timer);
    message?.classList.remove("show");
    message?.classList.add("hidden");
  }, 2000);
}
document.querySelector("#copyLink")?.addEventListener("click", async () => {
  const link = location.href;
  try {
    await navigator.clipboard.writeText(link);
    showSuccess();
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
});

document.querySelector("#copyTitle")?.addEventListener("click", async () => {
  const title = productData.title;
  try {
    await navigator.clipboard.writeText(title);
    showSuccess();
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
});

document
  .querySelector("#copyLinkAndTitle")
  ?.addEventListener("click", async () => {
    const title = productData.title;
    const link = location.href;
    try {
      await navigator.clipboard.writeText(`${title}\n${link}`);
      showSuccess();
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  });

document.querySelector("#searchTitle")?.addEventListener("click", async () => {
  const url = `/search?q=${productData.title}`;
  try {
    window.location.href = url;
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
});
